import { Injectable } from '@angular/core';
import { Lagerartikel } from '../types/lagerartikel';

@Injectable({ providedIn: 'root' })
export class LagerartikelService {

  async getLagerartikel(): Promise<Lagerartikel[]> {
    return new Promise((resolve) => resolve([]))
  }
}